export const companyDetails = {
  name: 'Motive8 Group'
};
